<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" id="newBranchSideBar"
              class="add-new-data-sidebar items-no-padding" spacer v-esc="escape" v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? "Yeni Şube" : "Şube Düzenle" }}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <div id="pager" class="mt-3">
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <h3 class="mx-auto my-3">{{ stepHeaders[step - 1] }}</h3>
        </vs-col>
      </vs-row>

    </div>
    <form data-vv-scope="form-1" v-show="step == 1" @keyup.enter="goNextStep">
      <div class="px-6">
        <template v-if="newBranch.photo">

<!-- Image Container -->
<div class="img-container w-1/4 mx-auto flex items-center justify-center">
  <img v-if="!needUpload2" :src="$baseUrl + newBranch.photo" alt="img" class="responsive">
  <img v-if="needUpload2" :src="newBranch.photo" alt="img" class="responsive">
</div>

<!-- Image upload Buttons -->
<div class="modify-img flex justify-between mt-5">
  <input type="file" class="hidden" ref="updateImgInput2" @change="updateCurrImg2" accept="image/*">
  <vs-button size="small" class="mr-4" @click="$refs.updateImgInput2.click()">Fotoğrafı Güncelle
  </vs-button>
  <vs-button size="small" color="danger" @click="newBranch.photo = null;">
    Fotoğrafı Sil
  </vs-button>
</div>
</template>

<div class="upload-img" v-if="!newBranch.photo">
<input type="file" class="hidden" ref="uploadImgInput2" @change="updateCurrImg2" accept="image/*">
<vs-button class="w-full" icon-pack="feather" icon="icon-arrow-up" @click="$refs.uploadImgInput2.click()">
  Fotoğraf Yükle
</vs-button>
</div>
        <vs-input id="name" name="Şube Adı" v-validate="'required|min:2|max:40|checkBranchName'"
                  v-model="newBranch.name" class="w-full" label-placeholder="Şube Adı"/>
        <span class="text-danger text-sm"
              v-show="errors.has('form-1.Şube Adı')">{{ errors.first('form-1.Şube Adı') }}</span>

        <vs-input id="code" name="Şube Kodu" v-validate="'required|checkBranchCode'" v-model="newBranch.branchCode"
                  class="w-full" icon-pack="feather" icon="icon-user" label-placeholder="Şube Kodu"/>
        <span class="text-danger text-sm"
              v-show="errors.has('form-1.Şube Kodu')">{{ errors.first('form-1.Şube Kodu') }}</span>

        <vs-input id="emailField" name="Email" v-validate="'email'" type="email" v-model="newBranch.email"
                  class="w-full" icon-pack="feather" icon="icon-mail" label-placeholder="Email"/>
        <span class="text-danger text-sm" v-show="errors.has('form-1.Email')">{{ errors.first('form-1.Email') }}</span>

        <vs-input id="phoneNumber" name="Telefon" v-mask="phoneMask" v-validate="'length:14'"
                  v-model="newBranch.phoneNumber" class="w-full" icon-pack="feather" icon="icon-phone"
                  label-placeholder="Telefon"/>
        <span class="text-danger text-sm"
              v-show="errors.has('form-1.Telefon')">{{ errors.first('form-1.Telefon') }}</span>

        <vs-input id="fax" name="Fax" v-mask="phoneMask" v-validate="'length:14'" v-model="newBranch.fax" class="w-full"
                  icon-pack="feather" icon="icon-pocket" label-placeholder="Fax"/>
        <span class="text-danger text-sm" v-show="errors.has('form-1.Fax')">{{ errors.first('form-1.Fax') }}</span>
        <vs-checkbox color="primary" class="my-2" v-model="newBranch.isOnline">Mobil Siparişe Uygun mu ?</vs-checkbox>
        <vs-checkbox color="primary" class="my-2" v-model="newBranch.isCenter">Merkez mi ?</vs-checkbox>
        <div>
        <label v-if="$isCenterBranch() && newBranch.isCenter==false">Merkez Şube Seçimi</label>
        <v-select label-placeholder="Merkez Şube Seçimi" v-model="selectedBranch" itemid="id" label="name" class="w-full" v-if="$isCenterBranch() && newBranch.isCenter==false"
            placeholder="Merkez şube seçimi" :options="$currentUser.branch.id == 1 ? lists : []" :clearable="false">
          </v-select>
        <span class="text-danger text-sm" v-show="errors.has('form-1.RootBranchId')">{{ errors.first('form-1.RootBranchId') }}</span>
      </div>
        <label>Fiyat Listesi Seçimi</label>
        <v-select label-placeholder="Fiyat Listesi Seçimi" v-model="selectedPriceList" itemid="id" label="name" class="w-full" v-if="$isCenterBranch()"
            placeholder="Fiyat Listesi Seçimi" :options="$currentUser.branch.id == 1 ? priceLists : []" :clearable="false">
          </v-select>
        <span class="text-danger text-sm" v-show="errors.has('form-1.BranchProductPriceListId')">{{ errors.first('form-1.BranchProductPriceListId') }}</span>
      </div>
    </form>
    <form data-vv-scope="form-2" v-show="step == 2" @keyup.enter="goNextStep">
      <div class="px-6">
        <vs-row vs-type="flex" vs-w="12" vs-align="center">
          <vs-col vs-type="flex" vs-w="11" class="pr-1">
            <gmap-autocomplete class="w-full border-all px-2 py-1" :select-first-on-enter="true" ref="autocomplete"
                               @place_changed="setPlace" :options="{fields: ['geometry']}">
            </gmap-autocomplete>
          </vs-col>
          <vs-col vs-type="flex" vs-w="1" class="pl-1">
            <vs-button size="small" @click="geolocate" class="w-full" color="primary" icon-pack="feather"
                       icon="icon-map-pin"/>
          </vs-col>
        </vs-row>
        <gmap-map ref="googMap" :options="{streetViewControl:false}" :center="center"
                  :zoom="zoomMap != 'undefined' ? zoomMap : 12" style="width:100%;  height: 400px;" class="mt-2"
                  @click="mapClicked">
          <gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" @click="markerClicked">
          </gmap-marker>
        </gmap-map>

        <!--        <span v-if="!isMarked" class="mt-4 text-danger text-smaller weight-600">-->
        <!--          Lütfen Konum İşaretleyiniz !-->
        <!--        </span>-->

        <v-select :disabled="cities.length == 0" id="cityField" name="Şehir" v-validate="'required'"
                  v-model="newBranch.city" itemid="id" label="name" placeholder="Şehir Seçimi.." :options="cities"
                  @input="setStateList" class="mt-4" :clearable="true"></v-select>
        <span class="text-danger text-sm" v-show="errors.has('form-2.Şehir')">{{ errors.first('form-2.Şehir') }}</span>

        <v-select :disabled="states.length == 0" id="state" name="İlçe" v-validate="'required'"
                  v-model="newBranch.state" itemid="id" label="name" placeholder="İlçe Seçimi.." :options="states"
                  class="mt-4"
                  :clearable="true"></v-select>
        <span class="text-danger text-sm" v-show="errors.has('form-2.İlçe')">{{ errors.first('form-2.İlçe') }}</span>

        <vs-textarea id="address" name="Adres" v-validate="'max:100'" v-model="newBranch.address"
                     class="w-full mt-4 mb-0" icon-pack="feather" icon="icon-calendar" label="Adres"/>
        <span class="text-danger text-sm" v-show="errors.has('form-2.Adres')">{{ errors.first('form-2.Adres') }}</span>
      </div>
    </form>
    <form data-vv-scope="form-3" v-show="step == 3" @keyup.enter="goNextStep">
      <div class="px-6">

        <div id="branchOwnerDetails">

          <template v-if="branchOwner.photo">

            <!-- Image Container -->
            <div class="img-container w-1/4 mx-auto flex items-center justify-center">
              <img v-if="!needUpload" :src="$baseUrl + branchOwner.photo" alt="img" class="responsive">
              <img v-if="needUpload" :src="branchOwner.photo" alt="img" class="responsive">
            </div>

            <!-- Image upload Buttons -->
            <div class="modify-img flex justify-between mt-5">
              <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
              <vs-button size="small" class="mr-4" @click="$refs.updateImgInput.click()">Fotoğrafı Güncelle
              </vs-button>
              <vs-button size="small" color="danger" @click="branchOwner.photo = null;">
                Fotoğrafı Sil
              </vs-button>
            </div>
          </template>

          <div class="upload-img" v-if="!branchOwner.photo">
            <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="w-full" icon-pack="feather" icon="icon-arrow-up" @click="$refs.uploadImgInput.click()">
              Fotoğraf Yükle
            </vs-button>
          </div>

          <vs-input id="firstName" name="Ad" v-validate="'required|min:2|max:30|alpha_spaces'"
                    v-model="branchOwner.firstName" class="w-full mt-6" icon-pack="feather" icon="icon-user-plus"
                    label-placeholder="Şube Sahibi Ad"/>
          <span class="text-danger text-sm" v-show="errors.has('form-3.Ad')">{{ errors.first('form-3.Ad') }}</span>

          <vs-input id="lastName" name="Soyad" v-validate="'min:2|max:30|alpha_spaces'" v-model="branchOwner.lastName"
                    class="w-full" icon-pack="feather" icon="icon-user" label-placeholder="Şube Sahibi Soyad"/>
          <span class="text-danger text-sm"
                v-show="errors.has('form-3.Soyad')">{{ errors.first('form-3.Soyad') }}</span>

          <vs-input id="taxId" name="Vergi Numarası" v-validate="'digits:10'" v-mask="taxMask"
                    v-model="branchOwner.taxId" class="w-full" icon-pack="feather" icon="icon-phone"
                    label-placeholder="Vergi Numarası"/>
          <span class="text-danger text-sm"
                v-show="errors.has('form-3.Vergi Numarası')">{{ errors.first('form-3.Vergi Numarası') }}</span>

          <vs-input id="taxInstitution" name="Vergi Dairesi" v-validate="'max:70|min:3'"
                    v-model="branchOwner.taxInstitution" class="w-full" icon-pack="feather" icon="icon-phone"
                    label-placeholder="Vergi Dairesi"/>
          <span class="text-danger text-sm"
                v-show="errors.has('form-3.Vergi Dairesi')">{{ errors.first('form-3.Vergi Dairesi') }}</span>

          <vs-input id="emailFieldOwner" name="Email" v-validate="'email'" type="email" v-model="branchOwner.email"
                    class="w-full" icon-pack="feather" icon="icon-mail" label-placeholder="Email"/>
          <span class="text-danger text-sm"
                v-show="errors.has('form-3.Email')">{{ errors.first('form-3.Email') }}</span>

          <vs-input id="phoneNumberOwner" name="Telefon" v-mask="phoneMask" v-validate="'length:14'"
                    v-model="branchOwner.phone" class="w-full" icon-pack="feather" icon="icon-phone"
                    label-placeholder="Telefon"/>
          <span class="text-danger text-sm"
                v-show="errors.has('form-3.Telefon')">{{ errors.first('form-3.Telefon') }}</span>

          <vs-textarea id="addressOwner" name="Adres" v-validate="'max:100'" v-model="branchOwner.address"
                       class="w-full mt-4" icon-pack="feather" icon="icon-calendar" label="Adres"/>
          <span class="text-danger text-sm"
                v-show="errors.has('form-3.Adres')">{{ errors.first('form-3.Adres') }}</span>

        </div>
      </div>
    </form>

    <form data-vv-scope="form-4" v-show="step == 4" @keyup.enter="submitData">
      <div class="px-6">
        <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="space-between" vs-align="center">
          <vs-col vs-type="block" vs-w="5.75">
            <span class="block w-full px-3 pb-1 text-smaller weight-500">
              Açılış
            </span>
            <vue-timepicker class="block w-full bg-white orderLogTimeFilter" :language="turkish"
                            v-model="selectedOpenTime"></vue-timepicker>
          </vs-col>
          <vs-col vs-type="block" vs-w="5.75">
            <span class="block w-full px-3 pb-1 text-smaller weight-500">
              Kapanış
            </span>
            <vue-timepicker class="block w-full bg-white orderLogTimeFilter" :language="turkish"
                            v-model="selectedCloseTime"></vue-timepicker>
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-1">
          <vs-row vs-type="flex" vs-w="12" class="dayDiv">
            <div class="w-full d-flex" @click="newBranch.branchWorkDays.monday = !newBranch.branchWorkDays.monday">
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start" vs-align="center" class="px-1">
                <span class="text-dark weight-500 text-small">
                  Pazartesi
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end" vs-align="center" class="px-1">
                <span class="text-primary weight-500 text-smaller">
                  {{ newBranch.branchWorkDays.monday ? 'Açık' : 'Kapalı' }}
                </span>
                <vs-switch disabled="true" v-model="newBranch.branchWorkDays.monday" color="primary" class="ml-3"/>
              </vs-col>
            </div>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="dayDiv">
            <div class="w-full d-flex" @click="newBranch.branchWorkDays.tuesday = !newBranch.branchWorkDays.tuesday">
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start" vs-align="center" class="px-1">
                <span class="text-dark weight-500 text-small">
                  Salı
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end" vs-align="center" class="px-1">
                <span class="text-primary weight-500 text-smaller">
                  {{ newBranch.branchWorkDays.tuesday ? 'Açık' : 'Kapalı' }}
                </span>
                <vs-switch disabled="true" v-model="newBranch.branchWorkDays.tuesday" color="primary" class="ml-3"/>
              </vs-col>
            </div>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="dayDiv">
            <div class="w-full d-flex"
                 @click="newBranch.branchWorkDays.wednesday = !newBranch.branchWorkDays.wednesday">
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start" vs-align="center" class="px-1">
                <span class="text-dark weight-500 text-small">
                  Çarşamba
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end" vs-align="center" class="px-1">
                <span class="text-primary weight-500 text-smaller">
                  {{ newBranch.branchWorkDays.wednesday ? 'Açık' : 'Kapalı' }}
                </span>
                <vs-switch disabled="true" v-model="newBranch.branchWorkDays.wednesday" color="primary" class="ml-3"/>
              </vs-col>
            </div>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="dayDiv">
            <div class="w-full d-flex" @click="newBranch.branchWorkDays.thursday = !newBranch.branchWorkDays.thursday">
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start" vs-align="center" class="px-1">
                <span class="text-dark weight-500 text-small">
                  Perşembe
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end" vs-align="center" class="px-1">
                <span class="text-primary weight-500 text-smaller">
                  {{ newBranch.branchWorkDays.thursday ? 'Açık' : 'Kapalı' }}
                </span>
                <vs-switch disabled="true" v-model="newBranch.branchWorkDays.thursday" color="primary" class="ml-3"/>
              </vs-col>
            </div>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="dayDiv">
            <div class="w-full d-flex" @click="newBranch.branchWorkDays.friday = !newBranch.branchWorkDays.friday">
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start" vs-align="center" class="px-1">
                <span class="text-dark weight-500 text-small">
                  Cuma
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end" vs-align="center" class="px-1">
                <span class="text-primary weight-500 text-smaller">
                  {{ newBranch.branchWorkDays.friday ? 'Açık' : 'Kapalı' }}
                </span>
                <vs-switch disabled="true" v-model="newBranch.branchWorkDays.friday" color="primary" class="ml-3"/>
              </vs-col>
            </div>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="dayDiv">
            <div class="w-full d-flex" @click="newBranch.branchWorkDays.saturday = !newBranch.branchWorkDays.saturday">
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start" vs-align="center" class="px-1">
                <span class="text-dark weight-500 text-small">
                  Cumartesi
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end" vs-align="center" class="px-1">
                <span class="text-primary weight-500 text-smaller">
                  {{ newBranch.branchWorkDays.saturday ? 'Açık' : 'Kapalı' }}
                </span>
                <vs-switch disabled="true" v-model="newBranch.branchWorkDays.saturday" color="primary" class="ml-3"/>
              </vs-col>
            </div>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="dayDiv">
            <div class="w-full d-flex" @click="newBranch.branchWorkDays.sunday = !newBranch.branchWorkDays.sunday">
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start" vs-align="center" class="px-1">
                <span class="text-dark weight-500 text-small">
                  Pazar
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end" vs-align="center" class="px-1">
                <span class="text-primary weight-500 text-smaller">
                  {{ newBranch.branchWorkDays.sunday ? 'Açık' : 'Kapalı' }}
                </span>
                <vs-switch disabled="true" v-model="newBranch.branchWorkDays.sunday" color="primary" class="ml-3"/>
              </vs-col>
            </div>
          </vs-row>
        </vs-row>
      </div>
    </form>
    <div class="flex mt-5 px-6 pb-4">
      <vs-button v-show="step != 1" icon-pack="feather" icon="icon-arrow-left" class="mr-auto" color="danger"
                 @click="step--;">Geri
      </vs-button>
      <vs-button v-show="step == 1" class="mr-auto" type="gradient" color="danger"
                 @click="isSidebarActiveLocal = false">
        Vazgeç
      </vs-button>
      <vs-button v-show="step != 4" icon-pack="feather" icon="icon-arrow-right" class="ml-auto" icon-after
                 @click="goNextStep">İleri
      </vs-button>
      <vs-button v-show="step == 4" class="ml-auto" color="success" type="gradient" @click="submitData">Kaydet
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import {
  tr
} from "vuejs-datepicker/src/locale";
import moduleBranch from "@/store/branch/moduleBranch.js"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {
  checkNewBranchCode,
  checkNewBranchName,
  createNewBranch,
  getBranchNameList2,
  getCenterNameList,
  updateBranch,
  getStateList,
  getCityList,
  uploadImage,
  getFullAdressFromMap
} from '@/api/Branch';
import {
    getBranchProductPriceLists
  } from "@/api/BranchProductPrice.js";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      },
    }
  },
  data() {

    return {
      center: {
        lat: 45.508,
        lng: -73.587
      },
      isMarked: false,
      markers: [],
      places: [],
      turkish: tr,
      lists: [],
      selectedOpenTime: "00:00",
      selectedCloseTime: "23:59",
      taxMask: "##########",
      needUpload: false,
      needUpload2: false,
      phoneMask: "#### ### ## ##",
      uploadResponse: "",
      selectedBranch:null,
      priceLists:[],
      selectedPriceList:null,
      ownerPhotoBinary: null,
      newBranch: {
        branchWorkDays: {
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
          sunday: true
        }
      },
      branchOwner: {
        photo: ""
      },
      states: [],
      cities: [],
      step: 1,
      stepHeaders: ["Şube Bilgileri", "Adres Bilgileri", "Yetkili Bilgileri", "Mesai Bilgileri"],
      checkedBranch: false,
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    zoomMap: {
      get() {
        if (this.$refs.googMap) {
          return this.$refs.googMap.$mapObject.data.map.zoom;
        } else return 12;
      },
      set(val) {
        this.$refs.googMap.$mapObject.data.map.zoom = val;
      }
    }
  },
  methods: {
    setPlace(place) {
      let lat = place.geometry.location.lat();
      let lng = place.geometry.location.lng();
      let marker = {
        lat: lat,
        lng: lng
      };
      this.center = marker;
      this.zoomMap = 15;
    },
    markerClicked(val) {
      let lat = val.latLng.lat();
      let lng = val.latLng.lng();
      let marker = {
        lat: lat,
        lng: lng
      };
      if (this.markers.length > 0 && this.markers[0].position.lat == marker.lat && this.markers[0].position.lng ==
        marker.lng) {
        this.markers = [];
        this.isMarked = false;
        if (this.newBranch) {
          this.newBranch.latitude = null;
          this.newBranch.longitude = null;
        }
      }
    },
    mapClicked(val) {
      this.isMarked = true;
      let lat = val.latLng.lat();
      let lng = val.latLng.lng();
      let marker = {
        lat: lat,
        lng: lng
      };
      this.markers = [];
      this.markers.push({
        position: marker
      });
      this.center = marker;
      this.zoomMap = 18;
      /*getFullAdressFromMap({
        lat: lat,
        lng: lng
      }).then(res => {
        if (res && res.status == 200) {
          this.newBranch.address = res.data[2];
          this.newBranch.city = this.cities.find(x => x.name.toLowerCase() == res.data[1].toLowerCase());
          this.getStateList(this.newBranch.city.id);
          this.newBranch.state = res.data[0];
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata : ' + res.status,
            text: 'Adres Bilgisi Yüklenemedi !'
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata !',
          text: 'Sunucu Bağlantı Hatası !'
        });
      });*/
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    escape() {
      if (this.isSidebarActiveLocal = true) this.isSidebarActiveLocal = false;
    },
    setStateList(city) {
      if (city) {
        this.newBranch.state = null;
        this.getStateList(city.id)
      } else {
        this.states = [];
        this.newBranch.state = null
      }
      
    },
    createNewBranchOwner: function () {
      this.branchOwner = {
        firstName: "",
        lastName: "",
        address: "",
        email: "",
        phone: "",
        taxId: "",
        id: 0,
        taxInstitution: "",
        email: "",
        photo: ""
      };
      this.ownerPhotoBinary = null;
    },
    uploadImage: async function () {
      let image = this.ownerPhotoBinary;
      let formData = new FormData();
      formData.append('image', image)
      await uploadImage(formData).then(res => {
        if (res && res.status == 200) {
          this.branchOwner.photo = "/StaticFiles/images/" + res.data;
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata : ' + res.status,
            text: 'Yetkili Fotoğrafı Yüklenemedi !'
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata !',
          text: 'Sunucu Bağlantı Hatası !'
        });
      });
    },
    uploadImage2: async function () {
      let image = this.branchPhotoBinary;
      let formData = new FormData();
      formData.append('image', image)
      await uploadImage(formData).then(res => {
        if (res && res.status == 200) {
          this.newBranch.photo = "/StaticFiles/images/" + res.data;
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata : ' + res.status,
            text: 'Şube Fotoğrafı Yüklenemedi !'
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata !',
          text: 'Sunucu Bağlantı Hatası !'
        });
      });
    },
    getStateList: function (cityId) {
      getStateList(cityId).then(res => {
        if (res && res.status === 200) {
          this.states = res.data;
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata : ' + res.status,
            text: 'İlçeler Yüklenemedi !'
          });
        }
      }).catch(error => {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata !',
          text: 'Sunucu Bağlantısı Başarısız !'
        });
      });
    },
    getCityList: function () {
      getCityList().then(res => {
        if (res && res.status === 200) {
          this.cities = res.data;
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata : ' + res.status,
            text: 'Şehirler Yüklenemedi !'
          });
        }
      }).catch(error => {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata !', ////// MAP BİLGİLERİ İÇİN İNPUT VE ÇALIŞMA SAATİNİ STRİNG YAPIP GÖNDER
          text: 'Sunucu Bağlantısı Başarısız !'
        });
      });
    },
    initValues() {
      this.needUpload = false;
      this.needUpload2 = false;
      this.ownerPhotoBinary = null;
      this.branchPhotoBinary = null;
      this.newBranch = {
        branchWorkDays: {
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: true,
          sunday: true
        }
      };
      this.branchOwner = {
        photo: ""
      };
      this.step = 1;
      this.checkedBranch = false;
      this.selectedOpenTime = "00:00";
      this.selectedCloseTime = "23:59";
    },
    submitData: async function () {
      let checker;
      checker = await this.$validator.validateAll('form-4');
      if (checker) {
        if (this.markers && this.markers.length > 0) {
          this.newBranch.latitude = this.markers[0].position.lat.toString();
          this.newBranch.longitude = this.markers[0].position.lng.toString();
        }
        this.newBranch.openTime = this.selectedOpenTime;
        this.newBranch.closeTime = this.selectedCloseTime;
        if (this.selectedBranch!=null) {
          this.newBranch.rootBranchId= this.selectedBranch.id;
        }
        if (this.selectedPriceList!=null) {
          this.newBranch.branchProductPriceListId= this.selectedPriceList.id;
        }
        (this.needUpload) ? await this.uploadImage() : null;
        (this.needUpload2) ? await this.uploadImage2() : null;
        this.newBranch.branchOwner = this.branchOwner;
        if (this.newBranch.id) {
          updateBranch(this.newBranch).then(res => {
            if (res && res.status == 200) {
              this.$store.dispatch("branch/updateBranch", res.data).then(data => {
                this.$vs.notify({
                  color: 'success',
                  title: 'Başarılı !',
                  text: 'Şube Güncelleme Başarılı ! '
                });
                this.$emit('closeSidebar');
                this.initValues();
                this.$validator.reset();
              });
            } else {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata : ' + res.status,
                text: 'Şube Güncelleme Başarısız ! '
              });
            }
          }).catch(() => {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata !',
              text: 'Sunucu Bağlantı Hatası ! '
            });
          });
        } else {
          this.newBranch.id = 0;
          this.branchOwner.id = 0;
          createNewBranch(this.newBranch).then(res => {
            if (res && res.status == 200) {
              this.$store.dispatch("branch/addBranch", res.data).then(data => {
                this.$vs.notify({
                  color: 'success',
                  title: 'Başarılı !',
                  text: 'Şube Ekleme Başarılı ! '
                });
                this.$emit('closeSidebar');
                this.initValues();
                this.$validator.reset();
              });
            } else {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Şube Ekleme Başarısız ! '
              });
            }
          }).catch(() => {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata !',
              text: 'Sunucu Bağlantı Hatası ! '
            });
          });
        }
      }
    },
    updateCurrImg(input) {
      this.needUpload = true;
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.branchOwner.photo = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
        this.ownerPhotoBinary = input.target.files[0];
      }
    },
    updateCurrImg2(input) {
      this.needUpload2 = true;
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.newBranch.photo = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
        this.branchPhotoBinary = input.target.files[0];
      }
    },
    getCheckBranchName: async function (newBranchName) {
      let id = this.newBranch.id == null ? 0 : this.newBranch.id
      await checkNewBranchName(newBranchName, id).then(res => {
        this.checkedBranchName = res.data;
      });
      return this.checkedBranchName;
    },
    getCheckBranchCode: async function (newBranchCode) {
      let id = this.newBranch.id == null ? 0 : this.newBranch.id
      await checkNewBranchCode(newBranchCode, id).then(res => {
        this.checkedBranchCode = res.data;
      });
      return this.checkedBranchCode;
    },
    goNextStep: function () {
      switch (this.step) {
        case 1:
          this.$validator.validateAll('form-1').then(result => {
            if (result) {
              this.step++;
            }
          });
          break;
        case 2:
          this.$validator.validateAll('form-2').then(result => {
            if (result) {
              this.step++;
            }
          });
          break;
        case 3:
          this.$validator.validateAll('form-3').then(result => {
            if (result) {
              this.step++;
            }
          });
          break;
        default:
          break;
      }
    },
  },
  components: {
    VuePerfectScrollbar,
    VueTimepicker
  },
  watch: {
    isSidebarActive: function (val) {
    this.selectedBranch=this.lists.find(x=>x.id=== this.data.rootBranchId)
    this.selectedPriceList = this.priceLists.find(x=>x.id=== this.data.branchProductPriceListId)
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.geolocate();
        this.$validator.reset();
      } else {
        this.branchOwner = _.cloneDeep(this.data.branchOwner);
        this.newBranch = _.cloneDeep(this.data);
        let lat = this.newBranch.latitude;
        let lng = this.newBranch.longitude;
        if (lng != null && lng != "" && lat != "" && lat != null) {
          let marker = {
            latLng: {
              lat: function () {
                return Number.parseFloat(lat);
              },
              lng: function () {
                return Number.parseFloat(lng);
              }
            }
          }
          this.mapClicked(marker)
        }
        this.selectedOpenTime = this.newBranch.openTime;
        this.selectedCloseTime = this.newBranch.closeTime;
        this.needUpload = false;
        this.newBranch.city = this.data.state.city;
        if (this.newBranch.city != null) this.getStateList(this.newBranch.city.id);
      }
    },
    selectedOpenTime(val) {
      if (!val) return;
      let openTime = val.split(":");
      if (openTime[0] == "HH") this.selectedOpenTime = "00:" + openTime[1];
      else if (openTime[1] == "mm") this.selectedOpenTime = openTime[0] + ":00";
    },
    selectedCloseTime(val) {
      if (!val) return;
      let closeTime = val.split(":");
      if (closeTime[0] == "HH") this.selectedCloseTime = "00:" + closeTime[1];
      if (closeTime[1] == "mm") this.selectedCloseTime = closeTime[0] + ":00";
    },
  },
  mounted: function () {
    this.selectedBranch==this.lists.find(x=>x.id=== this.data.rootBranchId)
    this.getCityList();
  },
  created: async function () {
    /// checkBranchName Validation Setting
    this.lists = (await getCenterNameList()).data;
    this.priceLists = await getBranchProductPriceLists();
    this.priceLists.push({id:0,name:'Standart Liste'});
    let nameChecker = this.getCheckBranchName;
    let getBackName;
    this.$validator.extend('checkBranchName', {
      getMessage: 'Bu İsim Kullanımda',
      validate: async function (value, field) {
        await nameChecker(value).then(res => {
          getBackName = res
        });
        return !getBackName;
      }
    });
    let codeChecker = this.getCheckBranchCode;
    let getBackCode;
    this.$validator.extend('checkBranchCode', {
      getMessage: 'Bu Kod Kullanımda',
      validate: async function (value, field) {
        await codeChecker(value).then(res => {
          getBackCode = res
        });
        return !getBackCode;
      }
    });
  }
}

</script>

<style lang="scss" scoped>
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: red;
  text-transform: lowercase;
  font-variant: small-caps;
}

.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.tabPager {
  background-color: darkgreen;
  border-radius: 50%;
}

</style>

<style>
#newBranchSideBar .vs__dropdown-menu {
  max-height: 20vh !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
}

.orderLogTimeFilter input {
  padding: .7em .5em !important;
  border-radius: .4rem;
  width: 100% !important;
  height: unset !important;
}

.dayDiv {
  border-bottom: 1px solid #00000030;
  cursor: pointer;
  padding-top: .75rem;
  padding-bottom: .75rem;
}

.dayDiv .vs-switch {
  opacity: 1 !important;
}

.pac-container {
  z-index: 10000000000 !important;
}

#newBranchSideBar .vs-sidebar .vs-sidebar--items {
  overflow-y: auto !important;
}

</style>
